"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.form.hero.title': '加入IntHub',
    'register.form.hero.description': '请使用此表单注册。',
    'register.form.hero.login_link_text': '如果您已经是会员，请',
    'register.form.hero.login_link': '在此登录。',
};
